// app-wide store not needed at the moment

//@flow
import {
  OrderedMap
} from 'immutable';

import {
  ReduceStore
} from 'flux/utils';

import Dispatcher from 'app/Dispatcher';
import {
  ActionTypes
} from './actions';

class appStore extends ReduceStore<Object> {
  constructor() {
    super(Dispatcher);
  }

  getInitialState(): Object {
    return OrderedMap();
  }

  reduce(state: Object, action: Object): Object {
    switch (action.type) {
      case ActionTypes.SET_BRAND_FOCUS:
        if (action.brand)
          return state.set("brand", { id: action.brand.id, name: action.brand.label });
        return state.set("brand", null);
      default:
        return state;
    }
  }
}

export default new appStore();